// extracted by mini-css-extract-plugin
module.exports = {"container":"about_container__2uhrz","content":"about_content__1iqZQ","logo":"about_logo__1vogH"};